<template>
  <LcCard body-class="p-none" class="winners-card" radius="large" shadow="none">
    <div class="content flex flex-col items-start gap-100 px-300 py-200">
      <p class="count">{{ formattedCount }}</p>
      <div class="flex flex-col items-start">
        <h2 class="headline-h5-headline">
          {{ $t('highfrequencygame.hub.winnerscard.headline') }}
        </h2>
        <LcBadge class="label bg-accent-win-win flex justify-center">
          {{ $t('highfrequencygame.hub.winnerscard.label') }}
        </LcBadge>
      </div>
    </div>
  </LcCard>
</template>

<script lang="ts" setup>
type Props = { count: number }
const { count } = defineProps<Props>()

const formattedCount = computed(() => count.toLocaleString('en-US'))
</script>

<style lang="scss" scoped>
.winners-card {
  overflow: clip;
  background: token('color/background/accent/win/win-bold') url('./assets/winners-card.svg')
    no-repeat right -9.5rem center;
  color: token('color/text/primary/primary');

  .content {
    position: relative;
    height: 7.125rem;
  }

  .count {
    font-weight: token('font/headline/h5/weight');
    font-size: 3rem;
    line-height: 0.75;
  }

  .label {
    column-gap: token('size/space/gap/025');
    min-height: unset;
    padding: 0 token('size/space/gap/050');
    border-radius: token('size/radius/s');
  }

  @include media-desktop {
    background-position: right -3.875rem center;
  }
}
</style>
